// Frente F3 (fidelidade-3, 2026-09-23) — wrapper de `ui/Swatch` que aplica
// a cor REAL (hex/gradiente de color_hex_map) quando existe, e cai no
// círculo neutro com inicial (comportamento original de `ui/Swatch`) para
// estampas sem hex real (PANTERA, MESCLA, TIE DYE, ESTAMPADO, UNICA,
// COLORS). Não edita `ui/Swatch.tsx` (fora do escopo desta frente) —
// reaproveita a classe `.swatch` já tokenizada em index.css e só decide o
// `background` inline com dado real por item (mesma categoria de avatar
// de foto: não é token estático, é dado).
import type { CSSProperties } from "react";
import { resolveColorBackground, isLightHex, useColorHexMap } from "../../lib/color-swatch";
import { cn } from "../../lib/utils";

export interface ColorSwatchProps {
  name: string;
  selected?: boolean;
  className?: string;
  /** rem — diâmetro do círculo. Default acompanha `.swatch` (1.125rem). */
  size?: string;
}

/** Círculo de cor: hex/gradiente real quando `color_hex_map` conhece o
 * nome; senão inicial neutra (mesmo fallback de `ui/Swatch`). */
export function ColorSwatch({ name, selected, className, size }: ColorSwatchProps): JSX.Element {
  const map = useColorHexMap();
  const bg = resolveColorBackground(name, map);
  const initial = name.trim().slice(0, 1).toUpperCase() || "?";
  const isGradient = bg?.startsWith("linear-gradient");
  const needsLightBorder = !!bg && !isGradient && isLightHex(bg);

  const style: CSSProperties = {
    ...(size ? { width: size, height: size } : null),
    ...(bg
      ? {
          background: bg,
          color: "transparent",
          borderColor: needsLightBorder ? "var(--color-line)" : "transparent",
        }
      : null),
    ...(selected ? { borderColor: "var(--color-coral)", borderWidth: ".125rem" } : null),
  };

  return (
    <span
      className={cn("swatch", className)}
      style={style}
      title={name}
      aria-hidden
    >
      {bg ? null : initial}
    </span>
  );
}
